import { useCallback, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useNotifications } from '../../hooks/useNotifications';
import { AssetTypesService } from '../../services/assetTypesService';

const useAssetTypeSelect = ({ includeOnlyGeoActive, selectedId } = {}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [assetsTypes, setAssetsTypes] = useState([]);
  const [selectedOption, setSelectedOption] = useState(null);
  const { showErrorNotification } = useNotifications();

  const getAssetTypes = useCallback(async (search) => {
    setIsLoading(true);
    try {
      const data = await AssetTypesService.getAll({ search, page:1, includeOnlyGeoActive });
      setAssetsTypes(data.assetTypes);
    } catch (error) {
      showErrorNotification({
        title: 'error',
        description: 'errorRetrievingRecords',
      });
    } finally {
      setIsLoading(false);
    }
  }, [showErrorNotification]);

  useEffect(() => {
    getAssetTypes();
  }, []);

  // Resuelve el label del id seleccionado: lo busca en las opciones cargadas o lo trae por id
  useEffect(() => {
    if (!selectedId) {
      setSelectedOption(null);
      return undefined;
    }
    const inList = assetsTypes.find((assetType) => assetType._id === selectedId);
    if (inList) {
      setSelectedOption({ value: inList._id, label: inList.name });
      return undefined;
    }
    let active = true;
    AssetTypesService.getById(selectedId)
      .then(({ assetType }) => {
        if (active && assetType) setSelectedOption({ value: assetType._id, label: assetType.name });
      })
      .catch(() => {});
    return () => { active = false; };
  }, [selectedId, assetsTypes]);

  return {
    isLoading,
    getAssetTypes,
    assetsTypes,
    selectedOption,
  };
};

export default useAssetTypeSelect;

useAssetTypeSelect.propTypes = {
  includeOnlyGeoActive: PropTypes.bool,
  selectedId: PropTypes.string,
};
